import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Mail, Lock, Loader2 } from 'lucide-react';
import { Logo } from '../components/Logo';
export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('demo@jua.ai');
  const [password, setPassword] = useState('demo2024');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('/dashboard');
    }, 1500);
  };
  return <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-cyan-50 flex items-center justify-center p-6 relative overflow-hidden" data-id="element-3677">
      {/* Animated gradient orbs */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-pink-300/30 via-purple-300/30 to-transparent rounded-full blur-3xl animate-pulse" data-id="element-3678" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-cyan-300/20 via-purple-300/20 to-transparent rounded-full blur-3xl animate-pulse delay-1000" data-id="element-3679" />

      <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md relative z-10" data-id="element-3680">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-3681">
          <Logo size="lg" data-id="element-3682" />
        </div>

        {/* Login Card */}
        <div className="bg-white/60 backdrop-blur-xl border border-white/50 rounded-3xl p-8 shadow-2xl shadow-slate-200/50" data-id="element-3683">
          <div className="text-center mb-8" data-id="element-3684">
            <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-3685">
              Welcome Back
            </h1>
            <p className="text-slate-500 text-sm" data-id="element-3686">
              Access the energy trading dashboard
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-3687">
            <div className="space-y-1.5" data-id="element-3688">
              <label className="text-xs font-semibold text-slate-700 ml-1" data-id="element-3689">
                Email Address
              </label>
              <div className="relative" data-id="element-3690">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-3691" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@company.com" className="w-full pl-10 pr-4 py-3 bg-white/50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-pink-500/20 focus:border-pink-500/50 transition-all placeholder:text-slate-400" required data-id="element-3692" />
              </div>
            </div>

            <div className="space-y-1.5" data-id="element-3693">
              <label className="text-xs font-semibold text-slate-700 ml-1" data-id="element-3694">
                Password
              </label>
              <div className="relative" data-id="element-3695">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-3696" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" className="w-full pl-10 pr-4 py-3 bg-white/50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-pink-500/20 focus:border-pink-500/50 transition-all placeholder:text-slate-400" required data-id="element-3697" />
              </div>
            </div>

            <button type="submit" disabled={isLoading} className="w-full py-3.5 rounded-xl bg-gradient-to-r from-[#ff006b] to-[#a855f7] text-white font-semibold shadow-lg shadow-pink-500/30 hover:shadow-pink-500/40 hover:scale-[1.02] transition-all flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100 mt-2" data-id="element-3698">
              {isLoading ? <>
                  <Loader2 size={18} className="animate-spin" data-id="element-3699" />
                  Logging in...
                </> : <>
                  Log In
                  <ArrowRight size={18} data-id="element-3700" />
                </>}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-slate-200/60 text-center" data-id="element-3701">
            <p className="text-xs text-slate-500" data-id="element-3702">
              Don't have access?{' '}
              <a href="#" className="text-[#ff006b] font-medium hover:underline" data-id="element-3703">
                Contact sales
              </a>
            </p>
          </div>
        </div>
      </motion.div>
    </div>;
}